module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAQCAYAAABz9a1kAAABKklEQVRIicXTTStEURgA4McdCyX2s+EPWF0WZHxsFf9A2VA2foGi8AMsbCyklJUFCx+ZXyCxUTZKmA3RbCSZYrK4d0qaMdfX3Hd3zvv2nud03tM0GWY7sYZ+tGhsvOAUk5kw27aHITQ3GCE+swNdAfpSAHyO/gCPaStwH2A3bQV2AsziNkXEHZYCFDCAsxQQ56KPchfEG5eiod1oIGITvbiA4EPiGROYRukfASXMYBxPlc2gSuEqcrj5B0QBw1j5nKgGgRN04+APEXn04KhashYEihjFPMq/AJSxiBE81Cr6ClJpshA3Kf4AUcQY5tS5TD1IJfIIcfwNxInoKfaTFCeFEA3aIJZ9fbuyaBhzuE7aPBNm275h8YZDbMfrdrTiFVfYwhTW49rE8Q5Tgjq156im+AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/my-gift/row-bottom.png
// module id = 513
// module chunks = 1